import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=38ad730d&scoped=true&"
import script from "./TextField.vue?vue&type=script&lang=ts&"
export * from "./TextField.vue?vue&type=script&lang=ts&"
import style0 from "./TextField.vue?vue&type=style&index=0&id=38ad730d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad730d",
  null
  
)

export default component.exports